// extracted by mini-css-extract-plugin
module.exports = {"root":"JobManagement__root___R3Fiz","content":"JobManagement__content___v24ou"};